import { render } from "./PasswordChange.vue?vue&type=template&id=40a1c071&scoped=true&ts=true"
import script from "./PasswordChange.vue?vue&type=script&lang=ts"
export * from "./PasswordChange.vue?vue&type=script&lang=ts"

import "./PasswordChange.vue?vue&type=style&index=0&id=40a1c071&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a1c071"]])

export default __exports__